import { Breadcrumbs } from "shared/ui/breadcrumbs";
import { Button } from "shared/ui/button";
import { EVENT_ROUTE } from "shared/config/routes";
import { EventSchedule } from "shared/ui/event-schedule";
import { schedule } from "../lib/scheduleData";
import DownloadSchedule from "../assets/Program.pdf";
import styles from "./ProgramPage.module.scss";

export const ProgramPage = () => {
  const breadcrumbItems = [
    { label: "Главная", href: EVENT_ROUTE },
    { label: "Программа" },
  ];

  return (
    <div className={styles.pageContent}>
      <div className={styles.topSection}>
        <Breadcrumbs items={breadcrumbItems} />
        <div className={styles.topSection__titleBlock}>
          <p className={styles.topSection__title}>Расписание конгресса</p>
          <div className={styles.topSection__button}>
            <Button variant="primary" disabled={true}>
              Научная программа
            </Button>
          </div>
          <a
            className={styles.topSection__link}
            href={DownloadSchedule}
            download="Азбука_Рубцов_28.05.2026.pdf"
          >
            Скачать расписание конгресса
          </a>
        </div>
      </div>
      <div className={styles.programSection}>
        <EventSchedule items={schedule} />
      </div>
    </div>
  );
};
